<template>
  <div>
    <header class="header" ref="header">
      <el-row type="flex" class="page-header">
        <el-col :span="15" class="header-left" style="width: 62.5%; border-right: none">
          <div class="sysname">随寓知己管理系统</div>
          <el-breadcrumb separator="/" class="breadcrumb">
            <el-breadcrumb-item v-for="(item, index) in levelList" :key="item.path" v-show="item.meta.title">
              <span v-if="
                  item.redirect === 'noredirect' ||
                  index == levelList.length - 1
                " class="no-redirect">{{ item.meta.title }}</span>
              <span v-else-if="item.redirect === ''">
                {{ item.meta.title }}
              </span>
              <router-link v-else :to="item.redirect || item.path">{{
                item.meta.title
              }}</router-link>
            </el-breadcrumb-item>
          </el-breadcrumb>
        </el-col>
        <el-col :span="9">
          <el-dropdown trigger="hover" menu-align="start" class="headImg-pos el-dropdown-link">
            <div class="clear">
              <div class="headIco dpl-ib">
                <img src="../../../static/img/headIco.png" />
              </div>
              <div class="dpl-ib head-name">
                <p class="username">{{ username }}</p>
                <p class="role" v-if="false">{{ role }}</p>
              </div>
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item><span class="link-a" @click="forgot">修改密码</span></el-dropdown-item>
              <!-- :to="{ path: '/login', query: { name: 'forgot' } }" -->
              <el-dropdown-item><span class="link-a" @click="exit">退出</span></el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-dropdown v-if="!isGudong" @command="openDialog" trigger="hover" menu-align="start" class="dropdown-pos el-dropdown-link plus">
            <!-- <div><i class="el-icon-plus"></i></div> -->
            <div class="el-icon-open">
              <img src="@/assets/imgs/common/plus.png" class="plusimg" />
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="新增片区" class="dropDown">新增片区</el-dropdown-item>
              <el-dropdown-item command="房源上线配置" class="dropDown">房源上线配置</el-dropdown-item>
              <el-dropdown-item command="新增房东合同next" class="dropDown">新增房东合同(新版)</el-dropdown-item>
              <!-- <el-dropdown-item command="新增房东合同" class="dropDown">新增房东合同</el-dropdown-item> -->
              <el-dropdown-item command="新增房源" class="dropDown">新增房源</el-dropdown-item>
              <el-dropdown-item v-if="visible['x-not-house-add']" command="x-not-house-add" class="dropDown">录入其他类型房源</el-dropdown-item>
              <el-dropdown-item command="新增企业合同" class="dropDown">新增企业合同</el-dropdown-item>
              <!-- <el-dropdown-item command="新增房源预定" class="dropDown">新增房源预定</el-dropdown-item> -->
              <!-- <el-dropdown-item v-if="this.$store.state.currentUser.roleData.indexOf('合同录入员') !== -1" command="新增租客纸质合同" class="dropDown">新增租客纸质合同</el-dropdown-item> -->
              <!-- v-if="isHouseKeeper" -->
              <el-dropdown-item command="新建维修工单" class="dropDown">新增维修(新版)</el-dropdown-item>
              <el-dropdown-item v-if="canSithdrawHouse" command="房源下架" class="dropDown">房源下架</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </el-col>
      </el-row>
      <el-row type="flex" :class="showTabCur ? 'page-basic' : 'page-basic display-none'" v-if="canAreaFilterShow === 'show'">
        <slot name="tabs" v-if="tabList && tabList.length > 0">
          <ul class="tabs-ul">
            <li v-for="(tab, index) in tabList" :key="index" :class="activeTab == index ? 'active' : ''" @click="optTab(index)">
              <el-badge :value="tab.num" class="item">{{ tab.title }}</el-badge>
            </li>
          </ul>
        </slot>
        <div class="area-wrap">
          <!-- 区域过滤组件 -->
          <areaFilter @heightChange="heightChange" :areaNone="areaNone"></areaFilter>
        </div>

        <!-- </el-col> -->
      </el-row>
    </header>
    <appoint-form :houseAppoint="houseAppointData" :form="form"></appoint-form>
    <reserve-form :reserveForm="reserveForm" :reserveFormData="reserveFormData"></reserve-form>
    <contract-form :contractForm="contractForm" :contractFormData="contractFormData"></contract-form>
    <!-- 新增企业合同 -->
    <div v-if="businessTenantShow">
      <businessTenantForm :businessTenantShow="businessTenantShow" :selectedList="selectedList" :opts="opts" :propertyInform="propertyInform" @closeBusinessTenantForm="closeBusinessTenantForm" @zoneAndBlock="zoneAndBlock" @openAddCompany="openAddCompany"></businessTenantForm>
    </div>
    <!-- 新增企业 -->
    <div v-if="addCompanyShow">
      <addBusinessForm :addCompanyShow="addCompanyShow" :addCompanyData="addCompanyData" @closeAddCompany="closeAddCompany"></addBusinessForm>
    </div>
    <!-- 企业合同 房间选择 -->
    <div v-if="houseSelectShow">
      <businessHouseSelect :tzEndTime="tzEndTime" :tenantId="tenantId" :timeRange='timeRange' :houseSelectData="houseSelectData" @getHouseList="getHouseList" @closeAddCompany="closeAddCompany"></businessHouseSelect>
    </div>
    <!-- 企业合同 填写物业交割清单 -->
    <div v-if="propertyShow">
      <propertyForm :nenghaoMessage="propertyInform.nenghaoMessage" :wuyeMessage="propertyInform.wuyeMessage" :rentType="propertyInform.wuyeInform.rentType" @getPropertySet="getPropertySet" @closeAddCompany="closeAddCompany"></propertyForm>
    </div>
    <div v-if="visible['house-withdraw-dialog']">
      <House-withdraw-form @closeHouseWithdraw="closeHouseWithdraw"></House-withdraw-form>
    </div>
    <!-- 新增片区 -->
    <div v-if="visible['add-area-dialog']">
      <Add-area-form @closeAddArea="closeAddArea"></Add-area-form>
    </div>
    <!-- 房源上线 -->
    <div v-if="visible['house-res-dialog']">
      <House-res-config @closeHouseRes="closeHouseRes"></House-res-config>
    </div>

    <el-dialog title="新增房源" :close-on-click-modal="false" :visible.sync="dialogAddVisible" top="7%">
      <depositAdd :formLabelWidth="formLabelWidth" :mix="mix" :disable="false" @listenToParentEvent="closeForm" @addSuccess="closeForm"></depositAdd>
    </el-dialog>
    <el-dialog v-if="dialogVisible" :close-on-click-modal="false" title="新增房东合同" :visible.sync="dialogVisible" class="trusteeship" top="7%">
      <trusteeshipAdd :disabled="false" :addclickCount="addclickCount" :formLabelWidth="formLabelWidth" :mix="mix" @listenToParentEvent="closeForm" @addTrusteeshopSuccess="closeForm"></trusteeshipAdd>
    </el-dialog>
    <!-- 新建弹窗开始 -->
    <!-- <el-dialog
      title="新增维修"
      :close-on-click-modal="false"
      :visible.sync="repairAddVisible"
    >
      <repairAdd
        @closeForm="closeForm"
        :addclickCount="addclickCount"
        :repairShow="repairShow"
      ></repairAdd>
    </el-dialog> -->
    <div v-if="visible['repair-add']">
      <repair-add :addclickCount="addclickCount" @closeRepair="closeRepair"></repair-add>
    </div>
    <!-- 新建弹窗结束 -->
    <!-- 新建弹窗开始 -->
    <el-dialog title="新增保洁" :close-on-click-modal="false" :visible.sync="cleanAddVisible">
      <cleanAdd @closeForm="closeForm" service="clean"></cleanAdd>
    </el-dialog>
    <!-- 新建弹窗结束 -->

    <trusteeship-start-dialog v-if="visible['trusteeship-start-dialog']" @close="close('trusteeship-start-dialog')" />
    <not-house-input-start-dialog v-if="visible['not-house-input-start-dialog']" @close="close('not-house-input-start-dialog')" />
  </div>
</template>
<script>
import AppointForm from '@/components/rent/AppointForm'
import ReserveForm from '@/components/rent/ReserveForm'
import ContractForm from '@/components/forms/ContractForm'
import repairAdd from '@/components/repairAdd'
import cleanAdd from '@/components/cleanAdd'
import areaFilter from '@/components/common/areaFilter'
import trusteeshipAdd from '@/components/forms/TrusteeshipForm'
import depositAdd from '@/components/forms/HouseForm'
import businessTenantForm from '@/components/forms/BusinessContractForm/index'
import addBusinessForm from '@/components/forms/AddBusinessForm/index'
import businessHouseSelect from '@/components/forms/BusinessContractForm/businessHouseSelect'
import propertyForm from '@/components/forms/BusinessContractForm/propertyForm'
import HouseWithdrawForm from '@/components/forms/HouseWithdrawForm/index'
import AddAreaForm from '@/components/forms/AddAreaForm/index'
import HouseResConfig from '@/components/forms/HouseResConfig/index'

// 房东合同流程发起
import TrusteeshipStartDialog from '@/page/none/workflow/trusteeship/start-dialog'
import NotHouseInputStartDialog from '@/page/none/workflow/not-house-input/start-dialog'

// import Cookies from 'js-cookie'
import accountUrl from '@/xhr/services/account'
export default {
  name: 'topHeader',
  props: {
    showTab: {
      type: Boolean,
      default: true,
    },
    canAreaFilterShow: {
      type: String,
      default: 'show',
    },
  },
  data: function () {
    return {
      timeRange: '',
      showTabCur: true,
      levelList: [],
      tabList: [],
      areaNone: true,
      activeTab: 0,
      username: '',
      role: '',
      active: true,
      navtype: 'horizontal',
      navselected: '',
      houseAppointData: {
        show: false,
      },
      isCeo: false,
      isGudong: this.$store.state.currentUser.isGudong,
      formLabelWidth: '120px',
      reserveForm: {
        show: false,
      },
      dialogVisible: false,
      dialogAddVisible: false,
      contractForm: {
        show: false,
      },
      form: {
        goTime: '',
        rentRange: '',
        source: '',
      },
      reserveFormData: {
        goTime: new Date(),
        startTime: '',
        endTime: '',
        rentRange: '',
        rentType2: '',
        source: '',
      },
      contractFormData: {
        name: '',
        phone: '',
        certificateType: '',
        cardId: '',
        sex: '',
        houseSpaceName: '',
        earnestShow: false,
        startTime: '',
        endTime: '',
        rentRange: '',
        rentMoney: '',
        deposit: '', // 押金
        rentFreeStart: '',
        rentFreeEnd: '',
        rentType2: '', // 支付周期
        firstMoney: '',
        earnest: '',
        addCycle: '',
        addType: 'NOTRISE',
        source: '',
        livesNumber: '',
        memo: '',
        signType: 'NEW',
        projectTrue: '',
        people: '',
      },
      repairAddVisible: false,
      addclickCount: 0,
      cleanAddVisible: false,
      houseChange: {
        uId: '',
        houseId: '',
        businessId: '',
        blockName: '',
        detailAddress: '',
        effectTime: '', // 托管开始时间
        endTime: '', // 托管结束时间
        freeStartTime: '', // 免租开始时间
        freeEndTime: '', // 免租结束时间
        rental: '', // 收房价格
        deposit: '', // 押金
        payWay: '1',
        payCycle: '1', // 支付周期
        rentalStage: '0', // 租金递增方式
        rentalSMoney: '',
        buildingNo: '1', // 楼号
        unitNo: '1', // 单元号
        roomNo: '1', // 室号
        payeeName: '', // 收款人姓名
        bankAccount: '', // 收款账号
        bankName: '2', // 收款银行
        bankOfAccounts: '', // 开户支行
        remark: '',
        contractType: 'TRUSTEESHIPCONTRACT', // 合同分类
        repName: '', // 小管家姓名
        repPhone: '', // 小管家联系方式
        userName: '',
        cerType: 'ID', // 房东证件类型
        cerNum: '', // 房东证件号
        userPhone: '', // 房东手机号
      },
      mix: {
        userId: this.$store.state.accountUrl + 'user/info/cert/', // 根据ID搜索身份证号
        userUrl: this.$store.state.accountUrl + 'user/list', // 查询用户列表
        userSignUrl: this.$store.state.accountUrl + 'user/info/signin', // 查询用户信息
        depositAddUrl: this.$store.state.houseUrl + 'save/houseSpace/', // 新增托管
        contractAdd: this.$store.state.contractUrl + 'addDelegateContract', // 新增租客纸质合同
        houseList: this.$store.state.houseUrl + 'list/block', // 房源地址查找
      },
      repairShow: true,

      businessTenantShow: false,
      addCompanyShow: false,
      houseSelectShow: false,
      propertyShow: false,
      addCompanyData: {
        addAndDel: 'ADD', // 处理类型
        userBeanList: [
          // 企业信息
          {
            address: '', // 企业地址
            certNumber: '', // 证件号码
            certType: '', // 证件类型
            legalName: '', // 法人姓名
            city: '',
            province: '',
            phone: '',
            region: '', // 行政区
            tenantType: 'ENTERPRISE', // 租客类型
            username: '',
            userEnckosureBeans: [
              {
                addr: '1212121212',
                attachmentType: 'CERTIFICATES',
              },
            ], // 用户附件
          },
          // 负责人信息
          {
            username: '', // 负责人姓名
            phone: '',
            certType: '', // 证件类型
            certNumber: '', // 证件号码
            tenantType: 'HEADOFENTERPRISE', // 租客类型
            userEnckosureBeans: [
              {
                addr: '1212121212',
                attachmentType: 'CERTIFICATES',
              },
            ], // 用户附件
          },
        ],
      },
      tenantId: '',
      tzEndTime: new Date(),
      selectedList: [], // 已选择房间集合
      opts: {
        energyConfigList: [],
      },
      propertyInform: {
        wuyeMessage: [],
        nenghaoMessage: [],
        wuyeInform: {
          rentType: '',
          index: '',
        },
      }, // 物业交割单信息
      visible: {
        'trusteeship-start-dialog': false,
        'trusteeship-update-dialog': false,
        'not-house-input-start-dialog': false,
        'x-not-house-add': false,
        'house-withdraw-dialog': false,
        'add-area-dialog': false,
        'house-res-dialog': false,
        'repair-add': false,
      },
      houseSelectData: {
        blockId: '',
        buildingNo: '',
        loginId: this.$store.state.currentUser.uid,
        roomNo: '',
        tenantId: '',
        zoneId: '',
        isSelected: 0,
      },
    }
  },
  computed: {
    isHouseKeeper () {
      let roleData = this.$store.state.roleData
      return roleData.includes('小管家')
    },
    canSithdrawHouse () {
      let roleData = this.$store.state.roleData
      return (
        roleData.includes('运营专员') ||
        roleData.includes('运营主管') ||
        roleData.includes('运营部经理')
      )
    },
  },
  methods: {
    setOpts (opts) {
      this.opts = opts
    },

    loadPermission () {
      const roleData = this.$store.state.roleData
      const x0AllowedRoles = ['店长', '公寓部经理', '运营部经理']
      if (roleData.some((role) => x0AllowedRoles.includes(role))) {
        this.open('x-not-house-add')
      }
    },

    // 退出功能
    exit () {
      localStorage.clear()
      sessionStorage.clear()
      this.$router.push({ path: '/' })
    },
    forgot () {
      localStorage.clear()
      sessionStorage.clear()
      this.$router.push({ path: '/login?name=forgot' })
    },
    // 高度改变 同步影响外层的高度
    heightChange () {
      let headerHeight = this.$refs.header.offsetHeight
      this.$root.bus.$emit('topHeight', headerHeight)
    },

    // 切换tab的选型 ，切换数据列表的部分
    optTab (index) {
      this.activeTab = index
    },

    getBreadcrumb () {
      this.levelList = this.$route.matched.filter((item) => item.name)
    },
    getNavType () {
      this.navselected = this.$store.state.topIndex
    },
    openDialog (command) {
      if (command === '新增看房预约') {
        this.form.people = [localStorage.getItem('role'), this.username]
        this.houseAppointData.show = true
      } else if (command === '新增房源预定') {
        this.reserveFormData.people = [
          localStorage.getItem('role'),
          this.username,
        ]
        this.reserveForm.show = true
      } else if (command === '新增租客纸质合同') {
        this.contractFormData.people = [
          localStorage.getItem('role'),
          this.username,
        ]
        this.contractFormData.storageType = 'PAPER'
        this.contractFormData.sourceType = 'PAPER'
        this.contractForm.show = true
        this.contractFormData.storageTypeShow = true
      } else if (command === '新增房源') {
        this.dialogAddVisible = true
      } else if (command === '新增房东合同') {
        this.dialogVisible = true
        this.addclickCount++
      } else if (command === '新增企业合同') {
        this.businessTenantShow = true
      } else if (command === '新建维修工单') {
        this.open('repair-add')
        // this.repairShow = true
        // this.repairAddVisible = true
        this.addclickCount++
        console.log(this.addclickCount)
      } else if (command === '新增保洁') {
        this.cleanAddVisible = true
        this.addclickCount++
      } else if (command === '新增房东合同next') {
        this.open('trusteeship-start-dialog')
      } else if (command === 'x-not-house-add') {
        console.log('near 376')
        console.log('near 296')
        console.log('near 103')
        this.open('not-house-input-start-dialog')
      } else if (command === '房源下架') {
        this.open('house-withdraw-dialog')
      } else if (command === '新增片区') {
        this.open('add-area-dialog')
      } else if (command === '房源上线配置') {
        this.open('house-res-dialog')
      }
    },

    open (id) {
      // 'trusteeship-start-dialog'
      this.visible[id] = true
    },

    close (id) {
      // 'trusteeship-start-dialog'
      this.visible[id] = false
    },

    loadName () {
      accountUrl.getUserInfoByLoginId(this.$store.state.currentUser.uid).then(
        (response) => {
          var data = response.data
          if (data.code === 200) {
            this.username = data.data.username
            this.role = localStorage.getItem('role') || ''
            // context.commit('setUserName', data.data.username)
            this.$store.dispatch('getLoginName', {
              username: data.data.username,
            })
          }
        },
        function (response) {
          console.log(response.status)
        }
      )
    },
    closeForm () {
      this.repairShow = false
      this.dialogVisible = false
      this.dialogAddVisible = false
      this.repairAddVisible = false
      this.cleanAddVisible = false
      this.addclickCount++
    },
    closeBusinessTenantForm () {
      this.selectedList = []
      this.businessTenantShow = false
    },
    closeHouseWithdraw () {
      this.visible['house-withdraw-dialog'] = false
    },
    closeAddArea () {
      this.visible['add-area-dialog'] = false
    },
    closeHouseRes () {
      this.visible['house-res-dialog'] = false
    },
    closeRepair () {
      this.visible['repair-add'] = false
    },
    // 打开 新增企业表单
    openAddCompany (val) {
      let { openType, tenantId, tzEndTime, inform } = val
      if (openType === 'addCompany') {
        this.addCompanyShow = true
      } else if (openType === 'houseSelect') {
        this.houseSelectShow = true
        this.tenantId = tenantId
        this.tzEndTime = tzEndTime
      } else if (openType === 'property') {
        this.propertyShow = true
        this.propertyInform = inform
      }
    },
    // 关闭 新增企业表单
    closeAddCompany (val) {
      if (val === 'addCompany') {
        this.addCompanyShow = false
      } else if (val === 'houseSelect') {
        this.houseSelectShow = false
      } else if (val === 'property') {
        this.propertyShow = false
      }
    },
    // 通过发射的事件，获取 选取的房源
    getHouseList (val) {
      // console.log(val)
      this.selectedList = val // 获取已选择房源
    },
    // 物业交割数据
    getPropertySet (val) {
      let { articlesLists, energyConsumption } = val
      // this.propertyInform.wuyeMessage = articlesLists
      // this.propertyInform.nenghaoMessage = energyConsumption
      // this.propertyInform.wuyeInform.rentType = rentType
      let inform = {
        articlesLists,
        energyConsumption,
        wuyeInform: this.propertyInform.wuyeInform,
      }
      this.$root.bus.$emit('newPropertyInform', inform)
    },
    zoneAndBlock (val, timeRange) {
      if (timeRange) {
        this.timeRange = timeRange
      }
      let houseSelectData = this.houseSelectData
      this.houseSelectData = {
        ...houseSelectData,
        ...val,
      }
      console.log(this.houseSelectData, '0000')
    },
  },
  watch: {
    showTab (val) {
      this.showTabCur = val
    },

    // 监测store.state
    '$store.state.topIndex': 'getNavType',
    // 监听路由变化
    $route (to, from) {
      if (to.fullPath) {
        this.activeTab = 0 // 将 按钮颜色初始化
        this.showTabCur = true
        this.$store.commit('EMPTY_UNIT_IDS') // 将片区 ID 初始化
      }
      this.getBreadcrumb()
    },
  },
  components: {
    AppointForm,
    ReserveForm,
    ContractForm,
    depositAdd,
    trusteeshipAdd,
    cleanAdd,
    repairAdd,
    areaFilter,
    businessTenantForm,
    addBusinessForm,
    businessHouseSelect,
    TrusteeshipStartDialog,
    propertyForm,
    NotHouseInputStartDialog,
    HouseWithdrawForm,
    AddAreaForm,
    HouseResConfig,
  },
  created () {
    // 加载权限
    setTimeout(this.loadPermission.bind(this), 6000)

    this.loadName()
    // this.$store.dispatch('getRole', { id: this.$store.state.currentUser.uid })
    this.getBreadcrumb()

    // this.$store.dispatch('getRole', { id: this.$store.state.currentUser.uid })
    let _this = this

    this.$root.bus.$on('unhandleTotal', (total) => {
      if (_this.tabList[0]) _this.tabList[0].num = total
    })

    // 接收tab的数据
    this.$root.bus.$on('initNav', (nav) => {
      this.tabList = nav.navList
      this.optTab = (index) => {
        this.activeTab = index
        // 传入其对应的业务逻辑
        if (nav.navOpt) {
          nav.navOpt(index)
        }
      }
    })
    // 接收值判断区域多选是否应存
    this.$root.bus.$on('none', (none) => {
      this.areaNone = none
    })
  },
  mounted () {
    this.$nextTick(function () {
      let topHeight = this.$refs.header.offsetHeight
      this.$root.bus.$emit('topHeight', topHeight)
    })
  },
}
</script>
<style scoped lang="scss">
.display-none {
  display: none !important;
}
/* 头部导航 */
header {
  position: fixed;
  top: 0;
  left: 200px;
  right: 0;
  z-index: 10;
  transition: all 0.5s ease;
  /*border-top: solid 1px #3091F2;*/
  border-top: solid 1px #fff;
  background-color: #fff;
}
.page-header {
  box-shadow: 0px 2px 2px 0px rgba(224, 224, 224, 1);
  margin-bottom: 2px;
}
.page-basic {
  background: rgba(255, 255, 255, 1);
  display: flex;
  .tabs-ul {
    line-height: 30px;
    padding: 30px 0;
    position: relative;
    overflow: hidden;
    padding-left: 40px;
    &:after {
      content: '';
      display: inline-block;
      width: 1px;
      background: #ccc;
      height: 30px;
      position: absolute;
      right: 0;
      top: 30px;
    }
    & > li {
      font-size: 18px;
      margin-right: 40px;
      float: left;
      height: 30px;
      cursor: pointer;
      &.active,
      &:hover {
        color: #3cbfc4;
      }
    }
  }

  .area-wrap {
    padding: 15px 0;
    flex: 1;
    margin-left: 40px;
  }
}

header .el-menu-demo {
  padding-left: 30%;
}
.headIco {
  height: 50px;
  padding: 5px 10px 5px 80px;
  text-align: right;
  padding-left: 0;
}
.header-left {
  padding-left: 40px;
  line-height: 60px;
  .sysname {
    font-size: 22px;
    color: #333;
    float: left;
  }
  .breadcrumb {
    float: left;
    font-size: 18px;
    margin-left: 20px;
    line-height: 60px;
  }
}

.logo {
  height: 60px;
  /*background-color: #eef1f6;*/
  padding-left: 30px;
  padding-top: 5px;
}
.resetLogin {
  position: absolute;
  left: 50%;
  margin-left: -150px;
  width: 300px;
}
.head-img {
  text-align: center;
  height: 60px;
  line-height: 60px;
  /*background-color: #eef1f6;*/
}
.head-name {
  width: 92px;
  text-align: left;
  float: right;
  margin-right: 20px;
  padding-top: 12.5px;
  .username,
  .role {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .username {
    line-height: 20px;
    font-size: 14px;
    color: #333;
  }
  .role {
    line-height: 15px;
    font-size: 10px;
    color: #666;
  }
}
.dropdown-pos {
  float: right;
  line-height: 60px;
  text-align: center;
}
.headImg-pos {
  float: right;
}
.el-icon-open {
  float: right;
  width: 44px;
  height: 44px;
  background: #3cbfc4;
  border-radius: 50%;
  margin-top: 8px;
  margin-right: 80px;
  text-align: center;
  line-height: 44px;
  .plusimg {
    &:hover {
      cursor: pointer;
    }
    vertical-align: middle;
  }
}
header .el-menu {
  text-align: center;
  padding-left: 0;
}
.el-menu--horizontal .el-menu-item {
  display: inline-block;
  float: none;
}
.link-a {
  display: inline-block;
  width: 100%;
  font-size: 14px;
}
.el-menu {
  background-color: #fff;
}
.el-menu--horizontal .el-menu-item {
  font-size: 16px;
}
.dropDown {
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/topHeader.vue